import Constants from '@/Constants';
import Category from '@/models/Category';
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../style.scss';

interface Props {
    categoryType: Category;
}

const CategoryItem: React.FC<Props> = (props: Props) => {
    const { categoryType } = props;

    return (
        <div className="category-top-section-item item-container">
            <NavLink className="nav-link item-container item" draggable={false} exact to={`${Constants.CATEGORY}/${categoryType.id}`}>
                {categoryType.name}
            </NavLink>
        </div>
    );
};

export default CategoryItem;
